import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  paymentList: []
};

const paymentReducerSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    updatePayments(state, action) {
      return {
        ...state,
        paymentList: [...action.payload]
      };
    },
    updatePayment(state, action) {
      return {
        ...state,
        paymentList: state.paymentList.map((payment) => {
          if (payment._id === action.payload.id) {
            return action.data;
          }
          return payment;
        })
      };
    }
  }
});

export const paymentReducerAction = paymentReducerSlice.actions;
export const paymentReducers = paymentReducerSlice.reducer;
